import React, { Component } from "react";
import {
  Wrapper,
  CardBody,
  Title,
  Copy,
  Bold
} from "app/NativeComponents/common";

class SignupCopy extends Component {
  render() {
    return (
      <Wrapper>
        <CardBody>
          <Title>Complete your affiliate partner account</Title>
          <Copy>
            We need just a little more information before you can signup to be
            an affiliate partner. Complete the form below:
          </Copy>
        </CardBody>
      </Wrapper>
    );
  }
}

export default SignupCopy;
